<template>
  <v-container>
    <v-row>
      <v-col cols="12" lg="3" xl="3">
        <v-card class="mx-auto shadow-3" max-width="400" tile>
          <v-card-title class="secondary white--text">
            Campos
          </v-card-title>
          <draggable
            v-model="listItems"
            :options="componentsOptions"
            :clone="onClone"
          >
            <v-list-item
              v-for="(element, index) in listItems"
              :key="index"
              style="cursor: grab"
            >
              <v-list-item-icon>
                <v-icon v-text="element.icon"></v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ element.label }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </draggable>
        </v-card>
      </v-col>
      <v-col cols="12" lg="9" xl="8">
        <v-row>
          <v-col cols="12" md="6" lg="4">
            <v-hover v-slot:default="{ hover }">
              <v-btn
                rounded
                large
                :isLoading="isLoading"
                :disabled="isLoading"
                color="success"
                :class="hover ? 'shadow-2' : 'shadow-4'"
                class="px-8"
                @click="submitForm"
                >Crear formulario</v-btn
              >
            </v-hover>
          </v-col>

          <v-col cols="12">
            <v-card flat>
              <v-card-text>
                Formulario
              </v-card-text>
              <v-card-text>
                <draggable
                  v-model="listForm"
                  :options="formOptions"
                  @start="isDragging = true"
                  @end="isDragging = false"
                  class="accordion"
                >
                  <v-card
                    flat
                    v-for="(item, index) in listForm"
                    :key="index"
                    class="my-1"
                  >
                    <v-alert outlined dense color="green">
                      <v-row>
                        <v-col class="grow pt-8">
                          <label :for="item.name" class="text--secondary">
                            {{ item.label }}:
                          </label>
                        </v-col>
                        <v-col class="grow">
                          <div
                            v-if="['select'].includes(item.inputType)"
                            class="col-7"
                          >
                            <!-- <select class="form-control form-control-sm">
                          <option
                            v-for="(option, index) in item.value"
                            :key="index"
                            >{{ option.name }}</option
                          >
                        </select> -->
                            <v-select
                              dense
                              outlined
                              readonly
                              :items="item.value"
                              item-text="name"
                              item-value="value"
                              :label="item.placeholder"
                              :hint="item.hint != '' ? item.hint : ''"
                              :hide-details="item.hint != '' ? false : true"
                            >
                            </v-select>
                          </div>
                          <div
                            v-else-if="['radio'].includes(item.inputType)"
                            class="col-7"
                          >
                            <v-radio-group dense readonly>
                              <v-radio
                                v-for="(option, index) of item.value"
                                :key="index"
                                :label="option.name"
                                :value="option.value"
                              ></v-radio>
                              <!-- <input
                              :type="item.inputType"
                              :id="'Option-' + index"
                              :name="item.name + '-options'"
                              class=" col-1 form-check-input"
                              disabled
                            /> -->
                            </v-radio-group>
                          </div>
                          <div
                            v-else-if="['checkbox'].includes(item.inputType)"
                            class="col-7"
                          >
                            <v-checkbox
                              v-for="(option, index) of item.value"
                              :key="index"
                              v-model="checkbox"
                              :label="option.name"
                              :value="option.value"
                            ></v-checkbox>
                          </div>
                          <div v-else class="col-7 text-left">
                            <v-text-field
                              dense
                              readonly
                              outlined
                              full-width
                              persistent-hint
                              :type="item.inputType"
                              :label="item.placeholder"
                              :hint="item.hint != '' ? item.hint : ''"
                              :hide-details="item.hint != '' ? false : true"
                            ></v-text-field>
                          </div>
                        </v-col>
                        <v-col class="shrink">
                          <v-card-actions>
                            <v-row align="center" justify="end">
                              <v-btn icon>
                                <v-icon>mdi-pencil</v-icon>
                              </v-btn>
                              <v-btn icon @click="removeItem(index)">
                                <v-icon>mdi-trash-can-outline</v-icon>
                              </v-btn>
                            </v-row>
                          </v-card-actions>
                        </v-col>
                      </v-row>
                    </v-alert>

                    <!-- <v-card-text
                  class="border border-info rounded d-flex flex-row form-group bg-white"
                >
                  <div
                    class="col-1 d-flex flex-row p-0 justify-content-around align-items-start pt-1"
                  >
                    <a
                      :href="'#' + item.name + '-panel'"
                      data-toggle="collapse"
                      role="button"
                      aria-expanded="false"
                      aria-controls="#collapseOne"
                      title="Editar"
                    >
                      <i class="fas fa-pen fa-1x pin-btn"></i>
                    </a>
                  </div>
                </v-card-text> -->

                    <!-- Panel de Edición del input -->
                    <v-expand-transition>
                      <div :id="item.name + '-panel'" class="collapse">
                        <v-card-text class="grey lighten-5 pa-10">
                          <v-row>
                            <label
                              :for="item.name + '-label'"
                              class="col-form-label col-form-label-sm col-2"
                              >Label :</label
                            >

                            <v-text-field
                              dense
                              outlined
                              full-width
                              hide-details
                              type="text"
                              v-model="item.label"
                              :id="item.name + '-label'"
                              class=" col form-control form-control-sm"
                            ></v-text-field>

                            <div class="col-4 align-items-center">
                              <input
                                type="checkbox"
                                :id="item.name + '-required'"
                                :checked="item.required"
                                @click.stop="item.required = !item.required"
                                class="pin-btn"
                              />&nbsp;&nbsp;
                              <label
                                :for="item.name + '-required'"
                                class="col-form-label col-form-label-sm"
                                >Requerido</label
                              >
                            </div>
                          </v-row>

                          <v-row
                            class="mt-3"
                            v-if="
                              !['checkbox', 'radio'].includes(item.inputType)
                            "
                          >
                            <label
                              :for="item.name + '-hint'"
                              class="col-form-label col-form-label-sm col-4"
                              >Texto de ayuda :</label
                            >
                            <v-text-field
                              dense
                              outlined
                              full-width
                              hide-details
                              type="text"
                              :label="item.placeholder"
                              v-model="item.hint"
                              :id="item.name + '-hint'"
                              class=" col form-control form-control-sm"
                            ></v-text-field>
                          </v-row>

                          <v-card
                            outlined
                            v-if="
                              ['checkbox', 'radio', 'select'].includes(
                                item.inputType
                              )
                            "
                            class="mt-3 rounded"
                          >
                            <v-card-text>
                              <div class="row mb-2">
                                <h5 class="card-title col">
                                  Opciones de Selección
                                </h5>
                                <!-- <a
                            @click="addOption(item.value)"
                            class="col-1 mr-4 text-success"
                            data-toggle="tooltip"
                            data-placement="top"
                            title="Agregar Opción"
                          >
                            <i class="fas fa-plus-circle fa-2x"></i>
                          </a> -->
                                <v-btn
                                  small
                                  fab
                                  color="success"
                                  class="shadow-4"
                                  @click="addOption(item.value)"
                                >
                                  <v-icon>mdi-plus</v-icon>
                                </v-btn>
                              </div>
                              <draggable
                                element="ul"
                                v-model="item.value"
                                class="list-group"
                                :options="{
                                  group: { name: 'item.value' },
                                  animation: 200,
                                }"
                              >
                                <li
                                  v-for="(option, index) in item.value"
                                  :key="index"
                                  class="list-group-item list-group-item-action text-left d-flex flex-row"
                                >
                                  <div class="col-5">
                                    <label
                                      for=""
                                      class="col-form-label col-form-label-sm"
                                      >Label :</label
                                    >
                                    <v-text-field
                                      dense
                                      outlined
                                      full-width
                                      hide-details
                                      type="text"
                                      :label="item.placeholder"
                                      v-model="option.name"
                                      :id="'option-label-' + index"
                                      class="form-control form-control-sm"
                                    ></v-text-field>
                                  </div>
                                  <div class="col-5">
                                    <label
                                      for=""
                                      class="col-form-label col-form-label-sm"
                                      >Valor :</label
                                    >
                                    <v-text-field
                                      dense
                                      outlined
                                      full-width
                                      hide-details
                                      type="text"
                                      :label="item.placeholder"
                                      v-model="option.value"
                                      :id="'option-value-' + index"
                                      class="form-control form-control-sm"
                                    ></v-text-field>
                                  </div>
                                  <button
                                    v-if="item.value.length > 2"
                                    @click="removeOption(item.value, index)"
                                    class="col-1 close pin-btn ml-auto"
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    title="Eliminar"
                                  >
                                    <span aria-hidden="true">&times;</span>
                                  </button>
                                </li>
                              </draggable>
                            </v-card-text>
                          </v-card>
                        </v-card-text>
                      </div>
                    </v-expand-transition>
                    <!-- Fin de panel de edición del input -->
                  </v-card>
                </draggable>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { PbxHttpClient } from "@/services/httpclient";
import draggable from "vuedraggable";

export default {
  components: {
    draggable,
  },

  computed: {
    componentsOptions() {
      return {
        sort: false,
        group: {
          name: "panels",
          pull: "clone",
          put: false,
        },
      };
    },
    formOptions() {
      return {
        group: {
          name: "panels",
        },
        animation: 200,
      };
    },
  },

  data() {
    return {
      isLoading: false,
      listItems: [
        {
          icon: "mdi-alphabetical-variant",
          type: "input",
          inputType: "text",
          label: "Campo de Texto",
          placeholder: "",
        },
        {
          icon: "mdi-at",
          type: "input",
          inputType: "email",
          label: "Correo",
          placeholder: "username@example.com",
        },
        {
          icon: "mdi-pound",
          type: "input",
          inputType: "number",
          label: "Número",
          placeholder: "123",
        },
        // {
        //   icon: "mdi-calendar-range",
        //   type: "input",
        //   inputType: "date",
        //   label: "Campo de Fecha",
        // },
        {
          icon: "mdi-format-list-checkbox",
          type: "checklist",
          inputType: "checkbox",
          label: "Selección Multiple",
          placeholder: "",
          value: [
            {
              name: "Option 1",
              value: "option-1",
            },
            {
              name: "Option 2",
              value: "option-2",
            },
            {
              name: "Option 3",
              value: "option-3",
            },
          ],
        },
        {
          icon: "mdi-order-bool-ascending",
          type: "radios",
          inputType: "radio",
          label: "Radio group",
          placeholder: "",
          value: [
            {
              name: "Option 1",
              value: "option-1",
            },
            {
              name: "Option 2",
              value: "option-2",
            },
          ],
        },
        {
          icon: "mdi-list-box",
          type: "select",
          inputType: "select",
          label: "Lista",
          placeholder: "",
          value: [
            {
              name: "Option 1",
              value: "option-1",
            },
            {
              name: "Option 2",
              value: "option-2",
            },
            {
              name: "Option 3",
              value: "option-3",
            },
          ],
        },
      ],
      listForm: [],
      icons: {
        text: "fas fa-font",
        email: "fas fa-at",
        number: "fas fa-hashtag",
        date: "far fa-calendar-check",
        checkbox: "far fa-check-square",
        "checkbox-group": "fas fas-check-square",
        radio: "far fa-check-circle",
        select: "fas fa-bars",
      },
    };
  },

  methods: {
    onClone(el) {
      let input = JSON.parse(JSON.stringify(el));

      input.name = input.inputType + "-" + Date.now();
      input.required = false;
      input.hint = "";

      return input;
    },
    clearForm() {
      this.listForm = [];
    },
    addOption(values) {
      let num = values.length + 1;

      values.push({
        name: "Option " + num,
        value: "option-" + Date.now(),
      });
    },
    removeItem(index) {
      this.listForm.splice(index, 1);
    },
    removeOption(values, index) {
      values.splice(index, 1);
    },

    async submitForm() {
      this.isLoading = true;

      try {
        this.listForm.forEach(
          (question) => (question.survey_id = this.$route.params.SurveyId)
        );

        const payload = { data: this.listForm };

        const { data } = await PbxHttpClient.post("/surveys/question", payload);

        this.$snotify.success(`Preguntas creadas con éxito.`);

        this.$router.push({ name: "Crear Encuesta" });
      } catch (err) {
        this.$snotify.error(err.response?.data?.error, "¡Error!");
        this.isLoading = false;
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style></style>
